import Vue from "vue";
import Vuex from "vuex";
import store from "./store/index";
import Accordion from "./components/Accordion.vue";
import { mapFields } from "vuex-map-fields";
import VueTinySlider from 'vue-tiny-slider';
import VModal from "vue-js-modal";
import TermInvestmentCalculatorForm from "./components/TermInvestmentCalculatorForm.vue";
import CreditCardApplicationForm from "./components/CreditCardApplicationForm.vue";
import TemporaryPasswordForm from "./components/TemporaryPasswordForm.vue";

Vue.use(VModal);

// import SearchApp from "./components/search/SearchApp.vue";

/**
 * Set the wizard config context based on the wizardConfig Object which is set on the WizardPage.ss of the brand website
 * **/
// function hydrateApp() {
// }

/**
 * Set up config
 * **/
function init() {
  // hydrateApp();
  
  new Vue({
    el: "#app",
    data: {
        mainMenuOpen: false,
        childMenuOpenID: 0,
        grandchildMenuActiveID: 0,
        showGlossaryBackToTop: false,
    },
    components: {
      accordion: Accordion,
      'tiny-slider': VueTinySlider,
      'calculator-form': TermInvestmentCalculatorForm,
      'credit-card-form': CreditCardApplicationForm,
      'temporary-password-form': TemporaryPasswordForm,
    },
    store,
    mounted() {
      // add scroll event listener on pages with e-glossary element
      let glossaryEl = document.getElementById("e-glossary-top");
      if (glossaryEl) {
        window.addEventListener("scroll", this.detectPageScroll);
      }

      // add event listener for inline links
      // set timeout to allow for page load
      this.$nextTick(() => {
        setTimeout(() => {

          // check for inline element links in url
          let url = window.location.href;
          let inlineLink = url.split("#")[1];

          if (inlineLink) {
            this.inlineLinkSelected = inlineLink;
            // scroll to section
            const el = document.getElementById(inlineLink);

            const stickyHeader = document.querySelector(".e-inline-links");
            const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 74;

            if (el) {
              // Scroll to the element, adjusting for header offset
              const offset = el.offsetTop - stickyHeaderHeight;
              window.scrollTo({ top: offset, behavior: "smooth" });
            }
          }
        }, 200);
      });
      
    },
    computed: {
      ...mapFields([
          "inlineLinkSelected",
          "glossaryItemSelected",
      ]),
    },
    methods: {
      toggleMainMenu: function () {
        this.mainMenuOpen = !this.mainMenuOpen;
        // if menu closed, close children as well
        if (!this.mainMenuOpen) {
          this.childMenuOpenID = 0;
        }
      },
      toggleChildMenu: function (childMenuOpenID, event) {
        // check if mobile menu is operating
        // desktop should just do usual link behaviour        
        if (window.innerWidth < 960) {
          // prevent default link action
          event.preventDefault();

          // check if we're opening or closing menu
          if (this.childMenuOpenID === childMenuOpenID) {
            // close if is current open
            this.childMenuOpenID = 0;
          } else {
            this.childMenuOpenID = childMenuOpenID;
          }

          // open main menu if not open
          if (!this.mainMenuOpen) {
            this.mainMenuOpen = true;
          }
        }
      },
      toggleGrandchildMenu: function (grandchildMenuActiveID) {
        // this.childMenuActive = !this.childMenuActive;
        // check if we're opening or closing menu
        if (this.grandchildMenuActiveID === grandchildMenuActiveID) {
          // close if is current open
          this.grandchildMenuActiveID = 0;
        } else {
          this.grandchildMenuActiveID = grandchildMenuActiveID;
        }

        // open main menu if not open
        if (!this.mainMenuOpen) {
          this.mainMenuOpen = true;
        }
      },
      childMenuActive(id) {
        if (this.childMenuOpenID === id) {
          return true;
        }
        return false;
      },
      inlineElementGoToPage() {
        // for inline links dropdown
        let url = this.inlineLinkSelected;
        window.location.href = url;
      },
      inlineElementScrollToSection(event) {
        // for inline links as list
        if (!event) return;
      
        const url = event.target.getAttribute("href");
        if (!url) return;
      
        // get id from url
        const section = url.split("#")[1];
      
        if (!section) {
          // No section anchor, redirect to the full URL
          window.location.href = url;
          return;
        }
      
        const el = document.getElementById(section);
        if (!el) return;

        // check for the sticky header
        const stickyHeader = document.querySelector(".e-inline-links");
        const stickyHeaderHeight = stickyHeader ? stickyHeader.offsetHeight : 74; // add default height if not found
      
        // Scroll to the element, adjusting for header offset
        const offset = el.offsetTop - stickyHeaderHeight;
        window.scrollTo({ top: offset, behavior: "smooth" });
      },
      showModal: function (name) {
        this.$modal.show(name);
      },
      hideModal: function (name) {
        this.$modal.hide(name);
      },
      glossaryScrollTo(id) {
        let scrollToID = id;
        if (!scrollToID) {
          scrollToID = this.glossaryItemSelected;
        }
        let el = document.getElementById(scrollToID);
        el.scrollIntoView({ behavior: "smooth" });
      },
      detectPageScroll() {
        let scrollPosition = window.scrollY;
        let glossaryEl = document.getElementById("e-glossary-top");
        let glossaryPosition = glossaryEl.offsetTop;

        if (scrollPosition > glossaryPosition) {
          this.showGlossaryBackToTop = true;
        } else {
          this.showGlossaryBackToTop = false;
        }
      },
    }
  });
}

/**
 * jQuery like $(document).ready() method that you can call from anywhere
 * **/
function docReady(fn) {
  // see if DOM is already available
  if (
    document.readyState === "complete" ||
    document.readyState === "interactive"
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

/**
 * Document ready let's do our stuff
 * **/
docReady(function () {
  // DOM is loaded and ready for manipulation here
  init();
});